import React, { useEffect, useState, Fragment } from 'react';
import { motion } from 'framer-motion';
import { ActionButton } from './ActionButton';
function useCountdown() {
  const [seconds, setSeconds] = useState(23 * 3600 + 34 * 60 + 39);
  useEffect(() => {
    const timer = window.setInterval(() => setSeconds(value => Math.max(0, value - 1)), 1000);
    return () => window.clearInterval(timer);
  }, []);
  return [Math.floor(seconds / 3600), Math.floor(seconds % 3600 / 60), seconds % 60].map(value => String(value).padStart(2, '0'));
}
interface PricingProps {
  showAnchor?: boolean;
}
export function Pricing({
  showAnchor = false
}: PricingProps) {
  const [hours, minutes, seconds] = useCountdown();
  return <section id={showAnchor ? 'pricing' : undefined} className="bg-surface" data-id="element-114" data-mp="20slh2v74j9qj">
      <div className="bg-urgency-surface px-4 py-16 sm:py-20" data-id="element-115" data-mp="3h7ec29vkg0g3">
        <div className="mx-auto max-w-4xl text-center" data-id="element-116" data-mp="3h5tlevcdh1ni">
          <h2 className="font-display text-xl font-bold sm:text-2xl" data-id="element-117" data-mp="3c8tdeevypotr">
            💰 PRECIO DE LANZAMIENTO — CIERRA EN:
          </h2>
          <div className="mt-6 flex justify-center gap-3 sm:gap-6" role="timer" aria-label={`${hours} horas, ${minutes} minutos, ${seconds} segundos`} data-id="element-118" data-mp="3vyx9k642cai7">
            {[[hours, 'HS'], [minutes, 'MIN'], [seconds, 'SEG']].map(([value, label], index) => <Fragment key={label} data-id="element-119" data-mp="erbmhrntwa1u" data-mpi={index}>
                <div data-id="element-120" data-mp="eqab1m2whljl">
                  <p className="font-display text-5xl font-bold tabular-nums text-danger sm:text-7xl" data-id="element-121" data-mp="eqtj8b2r0vkf">
                    {value}
                  </p>
                  <p className="text-xs tracking-spaced text-foreground-subtle" data-id="element-122" data-mp="3i7sezifjy8eq">
                    {label}
                  </p>
                </div>
                {index < 2 && <span className="pt-2 font-display text-4xl text-danger sm:text-6xl" aria-hidden="true" data-id="element-123" data-mp="3n525l1eogq45">
                    :
                  </span>}
              </Fragment>)}
          </div>
          <p className="mt-6 text-foreground-subtle" data-id="element-124" data-mp="2ui7omeh2k8vf">
            Después sube. <b className="text-foreground" data-id="element-125" data-mp="2zgiygp7d6jdn">No vuelve.</b>
          </p>
          <div className="mx-auto mt-5 max-w-md rounded-xl border border-danger/20 bg-canvas p-4 text-left" data-id="element-126" data-mp="2rgl6rhlcj93t">
            <div className="flex justify-between text-sm font-medium text-danger-soft" data-id="element-127" data-mp="2mijr76n4prx3">
              <span data-id="element-128" data-mp="3177iv1tuthhr">Cupos al precio de lanzamiento</span>
              <span data-id="element-129" data-mp="315wilbzmarve">Quedan pocos</span>
            </div>
            <div className="mt-3 h-2.5 overflow-hidden rounded-full bg-track" data-id="element-130" data-mp="2w7bf93p2js2q">
              <div className="h-full w-[68%] rounded-full bg-danger" data-id="element-131" data-mp="28hqrm7hz06n4" />
            </div>
            <p className="mt-2 text-right text-xs text-foreground-faint" data-id="element-132" data-mp="23ixgumu2itqn">
              68% de los cupos ya tomados
            </p>
          </div>
        </div>
      </div>
      <div className="px-4 py-16 sm:py-24" data-id="element-133" data-mp="2ihhqsmhh79tj">
        <div className="mx-auto max-w-2xl" data-id="element-134" data-mp="2dgka6ec46nu5">
          <h2 className="text-center font-display text-3xl font-bold sm:text-4xl" data-id="element-135" data-mp="2dfio7etk8gxn">
            🍽️ TU SISTEMA COMPLETO
          </h2>
          <motion.div initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="mt-8 rounded-3xl border-2 border-primary bg-canvas p-6 shadow-featured sm:p-9" data-id="element-136" data-mp="3ow8usz1wbars">
            <div className="flex flex-col gap-4 sm:flex-row sm:justify-between" data-id="element-137" data-mp="57drf2fx8yan">
              <div data-id="element-138" data-mp="3ngo4uu5os4zl">
                <h3 className="font-display text-lg font-bold text-primary-soft" data-id="element-139" data-mp="3nhfxpx7wfom6">
                  PACK COMIDAS RESUELTAS™
                </h3>
                <p className="mt-1 text-sm text-foreground-subtle" data-id="element-140" data-mp="j0lj0u405tsc">
                  4 Volúmenes + 5 Bonos · Acceso inmediato
                </p>
                <p className="mt-3 text-sm text-primary-soft" data-id="element-141" data-mp="o22gefna2y46">
                  Tu sistema completo en PDF + 5 bonos estratégicos de regalo.
                </p>
              </div>
              <div className="shrink-0 sm:text-right" data-id="element-142" data-mp="e8loxiam5v3o">
                <p className="text-xs uppercase tracking-wider text-foreground-faint" data-id="element-143" data-mp="11z7iy5ns9euo">
                  Precio original
                </p>
                <p className="text-foreground-faint line-through" data-id="element-144" data-mp="16s0ogvr2sr7t">$65.000</p>
                <p className="mt-2 text-xs uppercase tracking-wider text-primary-soft/70" data-id="element-145" data-mp="3f8juua2lyf4p">
                  Precio lanzamiento
                </p>
                <p className="font-display text-4xl font-bold text-primary-soft" data-id="element-146" data-mp="3aas61ox9f94q">
                  $19.990
                </p>
                <p className="text-xs text-foreground-subtle" data-id="element-147" data-mp="31893l5xdyyj0">ARS</p>
              </div>
            </div>
          </motion.div>
          <ActionButton className="mt-7" showTrust data-id="element-148" data-mp="1rato4a0gz5s">
            🍽️ QUIERO MIS COMIDAS RESUELTAS
          </ActionButton>
        </div>
      </div>
    </section>;
}